import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, catchError, tap } from "rxjs/operators";
import { HttpClientService } from "./http-client.service";
import { FraePriceOption } from "../interfaces/frae.interface";

@Injectable({
  providedIn: "root",
})
export class FraeService {
  constructor(private apiHttp: HttpClientService) {}

  /**
   * Fetches the active Frae price catalog from the backend so the quoter can
   * populate its `frae_options` from the DB instead of hardcoded values.
   * Returns an empty array on error so callers can fall back to defaults.
   */
  public getFraePrices(): Observable<FraePriceOption[]> {
    return this.apiHttp.get<{ frae_options: FraePriceOption[] }>("/api/frae_prices").pipe(
      map((res) => res?.frae_options ?? []),
      tap(() => console.log("FraeService.getFraePrices: Ok.")),
      catchError((err) => {
        console.error("FraeService.getFraePrices error:", err);
        return of([]);
      })
    );
  }
}
